export default {
  "site_name": "HooBuy Boats",
  "site_tagline": "Guia de Compras Inteligentes na China",
  "nav_home": "Início",
  "nav_guide": "Guia",
  "nav_categories": "Categorias",
  "nav_blog": "Blog",
  "cta_hoobuy_sheet": "Hoobuy Sheet",
  "cta_buy_now": "Buy It Now",
  "cta_access": "Acessar HoobuySpreadsheet",
  "cta_explore": "Explorar Listas",
  "select_category": "Selecionar Categoria",
  "back_home": "← Voltar ao Início",
  "read_more": "Leia Mais",
  "footer_copyright": "© 2026 HooBuy Boats. Todos os direitos reservados.",
  "footer_description": "Guia de Compras 2026"
}